<template>
		<div id="nav">
			<router-link to="/" id="nav-logo">
				<img src="static/images/logo.png" alt="Apollo Logo"/>
				<!-- text logo if necessary -->
			</router-link>
			<!-- overflow-toggle -->
			<button id="nav-bar-mobile" v-on:click.prevent="mobileMenu" type="button"><img src="static/images/h.svg"/></button>
			
			<ul id="nav-bar">
				
				<!-- disabled links -->
				<li class="nav-item" v-if="!disabled"><router-link to="/adminproposal" class="nav-link" title="proposalA">---</router-link>
				</li>
				<li class="nav-item" v-if="!disabled"><router-link to="/supplierproductproposal" class="nav-link" title="proposalS">---</router-link>
				</li>

				<li v-if="!disabled" class="nav-item"><router-link to="/user" class="nav-link">User</router-link>
				<!-- v-if="issessionset" -->


				<li class="nav-item"><router-link to="/about" class="nav-link" title="about">About</router-link></li>
				<!--<li class="nav-item"><router-link to="/" class="nav-link">Home</router-link></li>-->
				<li class="nav-item"><router-link to="/products" class="nav-link">Products</router-link></li>
				<li class="nav-item"><router-link to="/locations" class="nav-link" title="locations">Locations</router-link></li>
				<!-- TEMP configuration suppliers -->
				<li class="nav-item"><a href="how-to.php" class="nav-link" title="suppliers">Suppliers</a></li>



				<li class="nav-item" v-if="issessionset"><router-link to="/user" class="cta cta-link-perm">{{ user.username }}</router-link></li>

				<!-- process logout here -->
				<li class="nav-item" v-if="issessionset"><a href="#" class="nav-link" title="logout" v-on:click.prevent="logout">Logout</a></li>

				<li class="nav-item" v-if="!issessionset"><router-link to="/login" class="cta">Log In</router-link></li>
				<li class="nav-item" v-if="!issessionset"><router-link to="/account-selection" class="cta cta-link-perm">Sign Up!</router-link></li>
				<li v-if="!disabled"><router-link class="cart-link" to="/cart">Cart: {{ cart }}</router-link></li>
			</ul>
		</div>
</template>

<script>
	export default{
		props: ['issessionset', 'user', 'cart'],
		data(){
			return{
				disabled: true
			}
		},
		methods: {
			mobileMenu: function(event){
				$("body").toggleClass("overflow-toggle");
				$("#nav-bar").slideToggle(490);
			},

			logout: function(event){
				this.$emit('logout');
			},

			//DOM responsive
			HeaderResponsive: function(self){
				var ww = $(window).outerWidth();
				if(ww < 992){
					$("#nav-bar > li > a").off();
					$("#nav-bar > li > a").click(function(){
						$("body").toggleClass("overflow-toggle");
						$("#nav-bar").slideToggle(490);
					});
				}else{
					$("#nav-bar > li > a").off();
				}
			}
		},
		mounted(){
			var self = this;
			
			this.HeaderResponsive(self);
			$(window).resize(function(){
				self.HeaderResponsive(self);
			})

		}
	}
</script>


// WEBPACK FOOTER //
// Header.vue?7ad01142